import React from 'react';

export default class PopupContent extends React.Component {

  render() {
    return (
      <div className="popup-content"
           style={{
             position: "fixed",
             top: `${this.props.top}px`,
             left: `${this.props.left}px`,
             bottom: "0px",
             right: "0px"
          }}>
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/PopupContent.js